"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.U64_MAX = exports.BIG_NUMBER_WAD = exports.WAD = exports.TEN = exports.ZERO = exports.SLOTS_PER_YEAR = exports.REAL_SLOTS_PER_DAY = exports.REAL_SLOTS_PER_YEAR = exports.REAL_SLOTS_TIME = exports.BIG_NUMBER_ZERO = exports.BIG_NUMBER_ONE = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const bn_js_1 = __importDefault(require("bn.js"));
exports.BIG_NUMBER_ONE = new bignumber_js_1.default(1);
exports.BIG_NUMBER_ZERO = new bignumber_js_1.default(0);
exports.REAL_SLOTS_TIME = 500;
exports.REAL_SLOTS_PER_YEAR = 1000 / exports.REAL_SLOTS_TIME * 60 * 60 * 24 * 365;
exports.REAL_SLOTS_PER_DAY = 1000 / exports.REAL_SLOTS_TIME * 60 * 60 * 24;
exports.SLOTS_PER_YEAR = 1000 / 400 * 60 * 60 * 24 * 365;
exports.ZERO = new bn_js_1.default(0);
exports.TEN = new bn_js_1.default(10);
exports.WAD = exports.TEN.pow(new bn_js_1.default(18));
exports.BIG_NUMBER_WAD = new bignumber_js_1.default(exports.WAD.toString());
exports.U64_MAX = new bn_js_1.default("ffffffffffffffff", "hex");
